import React, { useState } from 'react';
import './Home.css';
import { useLanguage } from '../../context/LanguageContext';
import { FiGlobe, FiBook, FiInfo, FiBell } from 'react-icons/fi';

const Home = () => {
  const { lang, setLang } = useLanguage();

  const content = {
    en: {
      level: "Level",
      coaching: "Coaching",
      tagline: "Unexpected Moments. Unforgettable Lessons",
      start: "Getting Started",
      courses: "Our Courses",
      about: "About Us",
      faq: "FAQ",
      mobileStart: "Start"
    },
    jp: {
      level: "レベル",
      coaching: "コーチング",
      tagline: "思いがけない瞬間が、忘れられない学びになる。",
      start: "詳しくはこちら",
      courses: "コース一覧",
      about: "私たちについて",
      faq: "よくある質問",
      mobileStart: "開始"
    }
  };

  const t = content[lang];

  return (
    <div className="home-wrapper">
      {/* Language Selector */}
      <div className="language-picker animate-text">
        <button
          className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
          onClick={() => setLang('en')}
        >
          EN
        </button>
        <span className="divider">|</span>
        <button
          className={`lang-btn ${lang === 'jp' ? 'active' : ''}`}
          onClick={() => setLang('jp')}
        >
          JP
        </button>
      </div>

      <div className="container-fluid min-vh-100 d-flex flex-column justify-content-between py-3 overflow-hidden">

        {/* Glavni deo: Tekst i Devetka - PRIBLIŽENI */}
        <div className="row align-items-center justify-content-center flex-grow-1 main-content-row g-0">

          <div className="col-auto d-flex align-items-center animate-text pe-md-4">
            <div className="red-vertical-line d-none d-md-block"></div>
            <div className="text-content ms-md-4 text-center text-md-start">
              <h1 className="level-text">{t.level}</h1>
              <h2 className="coaching-text">{t.coaching}</h2>
              <p className="tagline">{t.tagline}</p>
            </div>
          </div>

          <div className="col-auto animate-nine ps-md-4">
            <div className="lava-nine-mask"></div>
          </div>
        </div>

        {/* Donja Navigacija sa horizontalnim linijama */}
        <div className="animate-icons pb-5">
          <div className="footer-nav-container d-flex align-items-center justify-content-center">

            {/* Leva horizontalna linija */}
            <div className="decorative-line d-none d-lg-block"></div>

            <div className="icon-narrow-container mx-4">
              <div className="row g-0 justify-content-center">
                <div className="col-3 text-center">
                  <a href="/getting-started" className="nav-item">
                    <FiGlobe className="icon world" />
                    <span className="d-none d-sm-block">{t.start}</span>
                    <span className="d-block d-sm-none">{t.mobileStart}</span>
                  </a>
                </div>
                <div className="col-3 text-center">
                  <a href="/courses" className="nav-item">
                    <FiBook className="icon books" />
                    <span className="d-none d-sm-block">{t.courses}</span>
                    <span className="d-block d-sm-none">Courses</span>
                  </a>
                </div>
                <div className="col-3 text-center">
                  <a href="/about" className="nav-item">
                    <FiInfo className="icon about" />
                    <span className="d-none d-sm-block">{t.about}</span>
                    <span className="d-block d-sm-none">About</span>
                  </a>
                </div>
                <div className="col-3 text-center">
                  <a href="/faq" className="nav-item">
                    <FiBell className="icon faq" />
                    <span>{t.faq}</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Desna horizontalna linija */}
            <div className="decorative-line d-none d-lg-block"></div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;